export default {
    darkest: "#2E4057",
    dark: "#9AD4D6",
    normal: "#FF5964",
    normalWithAlpha: "#FF596455",
    light: "#FFE74C",
    lightest: "#FCFCFC", 
    backgroundTop: "#ff766f",
    backgroundBottom: "#ffdcb0",
    shadow: "#4e4e4e2e",
    key: "Gullskatten Theme"
  };
  


// WEBPACK FOOTER //
// ./src/utils/theme.default.js